import {default as Component} from './AddDomainResourceForm'
import {changeResourceUrl} from '../../redux/actions'
import {addDomainResource} from '../../redux/endpointActions'
import {connect} from 'react-redux'

const servicePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/domain/resource'

const AddDomainResourceForm = connect(
	(state) => ({
		resourceUrl: state.addDomainResourceForm.resourceUrl,
		disabled: state.addDomainResourceForm.disabled,
		err: state.addDomainResourceForm.err,
		addDomainResource: (state.login.isLoggedIn ?
			addDomainResource(servicePath, state.login.userToken.AuthenticationResult.AccessToken,
				state.login.userToken.AuthenticationResult.IdToken) : (resourceUrl) => (() => {
			}))
	}),
	(dispatch) => ({
		resourceUrlChanged: (resourceUrl) => {
			dispatch(changeResourceUrl(resourceUrl))
		},
		dispatch: dispatch
	}),
	(stateProps, dispatcherProps) => ({
		resourceUrl: stateProps.resourceUrl,
		disabled: stateProps.disabled,
		err: stateProps.err,
		resourceUrlChanged: dispatcherProps.resourceUrlChanged,
		submit: (resourceUrl) => {
			stateProps.addDomainResource(resourceUrl)(dispatcherProps.dispatch)
		},
	})
)(Component)

AddDomainResourceForm.defaultProps = {
	resourceUrl: null,
	disabled: null,
	resourceUrlChanged: null,
	submit: null
}

export default AddDomainResourceForm  


// WEBPACK FOOTER //
// ./src/components/AddDomainResourceForm/index.js